export enum RolesEnumList {
  NAME = 'name',
  DESCRIPTION = 'description',
  USERS = 'users',
  ACTIONS = 'actions',
}
